import {
  DestroyRef,
  Directive,
  inject,
  InputSignal,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgModel } from '@angular/forms';
import { SEARCH_DEBOUNCE_TIME } from '@thiememeulenhoff/types';
import { debounceTime } from 'rxjs';

@Directive()
export abstract class AbstractSearchDirective<
  T extends string,
> implements OnInit {
  #valueAccessor = inject(NgModel);

  #destroyRef = inject(DestroyRef);

  abstract readonly channelInput: InputSignal<T>;

  ngOnInit() {
    this.#valueAccessor.valueChanges
      ?.pipe(
        debounceTime(SEARCH_DEBOUNCE_TIME),
        takeUntilDestroyed(this.#destroyRef),
      )
      .subscribe((value) => {
        const channel = this.channelInput();
        if (channel && typeof value === 'string') {
          this.setSearch(channel, value);
        }
      });
  }

  protected abstract setSearch(channel: T, value: string): void;
}
